import { Box, Typography } from "@mui/material";
import { SxProps } from "@mui/material/styles";
import { ReactNode } from "react";
import TipsAndUpdatesOutlinedIcon from "@mui/icons-material/TipsAndUpdatesOutlined";
import {
  colorBackgroundInfo,
  colorBorderInfo,
  colorTextMuted,
  colorTextPrimary,
  radiusCard,
} from "src/design/tokens";

interface TipsCardProps {
  title: string;
  tips: string[];
  icon?: ReactNode;
  sx?: SxProps;
}

export const TipsCard = ({ title, tips, icon, sx }: TipsCardProps) => (
  <Box
    sx={{
      border: `1px solid ${colorBorderInfo}`,
      borderRadius: radiusCard,
      px: 3,
      py: 2,
      backgroundColor: colorBackgroundInfo,
      ...sx,
    }}
  >
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5 }}>
      {icon ?? <TipsAndUpdatesOutlinedIcon sx={{ fontSize: 18, color: colorTextMuted }} />}
      <Typography variant="subtitle2" sx={{ fontWeight: 600, color: colorTextPrimary }}>
        {title}
      </Typography>
    </Box>

    <Box component="ul" sx={{ m: 0, pl: 2.5 }}>
      {tips.map((tip, i) => (
        <Typography
          key={i}
          component="li"
          variant="body2"
          sx={{ color: colorTextMuted, mb: 0.5, lineHeight: 1.6 }}
        >
          {tip}
        </Typography>
      ))}
    </Box>
  </Box>
);
